/* esm.sh - d3-transition@3.0.1/src/transition/end */
export * from "/*d3-transition@3.0.1/esnext/src/transition/end.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/end.mjs";
